"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnIntegSc = void 0;
const base_1 = require("./base");
const sc_1 = require("../services/sc");
/**
 * SnapChat Pixel
 */
class AnIntegSc extends base_1.AnIntegBase {
    static isLoaded() {
        return sc_1.AnServSc.isLoaded();
    }
    static sendInit(siteCategory, userId, email, coupon) {
        sc_1.AnServSc.sendInit(this.getPixelId(siteCategory), null, null, null);
        return true;
    }
    static sendPage(siteCategory, userId, email) {
        if (userId !== null && email !== null) {
            sc_1.AnServSc.sendIdentify(this.getPixelId(siteCategory), userId, email);
        }
        sc_1.AnServSc.sendPage(this.getPixelId(siteCategory));
        return true;
    }
    static sendTrackQuizStartLegacy(siteCategory) {
        sc_1.AnServSc.sendEventAddToCart();
        return true;
    }
    static sendTrackQuizStart(siteCategory) {
        sc_1.AnServSc.sendEventAddToCart();
        return true;
    }
    static sendTrackClubCheckoutStart(siteCategory) {
        sc_1.AnServSc.sendEventStartCheckout();
        return true;
    }
    static sendTrackArriveSignupLoginLegacy(siteCategory) {
        sc_1.AnServSc.sendEventStartCheckout();
        return true;
    }
    static sendTrackClubAccountCreate(siteCategory, userId, email) {
        sc_1.AnServSc.sendIdentify(this.getPixelId(siteCategory), userId, email);
        sc_1.AnServSc.sendEventSignup();
        return true;
    }
    static sendTrackClubAccountCreateLegacy(siteCategory, userId, email) {
        sc_1.AnServSc.sendIdentify(this.getPixelId(siteCategory), userId, email);
        sc_1.AnServSc.sendEventSignup();
        return true;
    }
    static sendTrackClubThankyou(siteCategory, userId, email, price, style, color, coupon) {
        sc_1.AnServSc.sendEventPurchase(price);
        return true;
    }
    static sendTrackClubThankyouLegacy(siteCategory, userId, email, price, style, color, coupon) {
        sc_1.AnServSc.sendEventPurchase(price);
        return true;
    }
}
exports.AnIntegSc = AnIntegSc;
AnIntegSc.shouldSendEveryPage = true;
AnIntegSc.shouldSendTrackQuizStart = true;
AnIntegSc.shouldSendTrackQuizStartLegacy = true;
AnIntegSc.shouldSendTrackClubCheckoutStart = true;
AnIntegSc.shouldSendTrackArriveSignupLoginLegacy = true;
AnIntegSc.shouldSendTrackClubAccountCreate = true;
AnIntegSc.shouldSendTrackClubAccountCreateLegacy = true;
AnIntegSc.shouldSendTrackClubThankyou = true;
AnIntegSc.shouldSendTrackClubThankyouLegacy = true;
AnIntegSc.pixelId = {
    prod: {
        defaultId: "4b53c63d-2a37-474d-a08e-756a76d9d3bc",
        ecomm: null,
        club: null,
    },
    dev: {
        defaultId: "4b53c63d-2a37-474d-a08e-756a76d9d3bc",
        ecomm: null,
        club: null,
    },
};
